
import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';


@Component({
  selector: 'app-uploadfile-popup',
  templateUrl: './uploadfile-popup.component.html',
  styleUrls: ['./uploadfile-popup.component.scss']
})
export class UploadfilePopupComponent {

  popupForm!: FormGroup;
  list: any;

  fileContent: string | ArrayBuffer | null = null;
  uploadedFile: File | null = null;
  @Input() selectedFiles: File[] = [];
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  nextStep: boolean = false;
  uploadedFileName: any;
  isAutoCompleteOn: boolean = false;

  requestFormService: any;
  RequestFormService: any;

  constructor(
    public dialogRef: MatDialogRef<UploadfilePopupComponent>,
    private fb: FormBuilder,
    private cargoHeatingService:CargoheatingCommonService,

    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedFiles = data.files;
    this.popupForm = this.fb.group({});

  }


  onFileSelected(event: any) {
    if (event.target.files) {
      if (this.selectedFiles.length > 0) {
        Array.from(event.target.files).map((file: any) => {
          this.selectedFiles.push(file)
        })
      } else {
        this.selectedFiles = Array.from(event.target.files);
      }

    }
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);

    if (!mimeMatch) {
      throw new Error('Invalid base64 string format');
    }

    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  closeModal() {

    this.dialogRef.close();
  }

  deleteFile(file: File) {
    if (file === this.uploadedFile) {
      this.uploadedFile = null;
      this.uploadedFileName = null;
    } else {
      const index = this.selectedFiles.indexOf(file);
      if (index >= 0) {
        this.selectedFiles.splice(index, 1);
      }
    }
  }

  uploadfile() {
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }



  submitClick() {

    if (this.selectedFile.length > 0) {

      const jsonData = {

        sheet_name: 'K (2)',
        start_index: '15',
        end_index: '215',
      };

      console.log('JSON Data:', jsonData);
      console.log('this.selectedFiles:', this.selectedFiles);

      this.cargoHeatingService.postRequestForm(jsonData, this.selectedFiles).subscribe(
        (data: any) => {
          console.log('API Response:', data);
          this.toastr.success(ToasterMessages.ReportGenaration);
          this.closeModal();
        },
        (error: any) => {
          console.error('API Error:', error);
          this.closeModal();
          this.toastr.error(ToasterMessages.Error);

        }
      );
    } else {
      console.warn('No files selected.');
      this.closeModal();
      this.toastr.warning(ToasterMessages.FileValidation);
    }

  }
  selectedFile(jsonData: any, selectedFile: any) {
    throw new Error('Method not implemented.');
  }
  clearClick() {
    throw new Error('Method not implemented.');
  }
}




